// extracted by mini-css-extract-plugin
export var header_content = "choose_modal-module--header_content--4VE+S";
export var long_arrow_right = "choose_modal-module--long_arrow_right--uCW11";
export var modal_body = "choose_modal-module--modal_body--t-p9P";
export var modal_register_role__item = "choose_modal-module--modal_register_role__item--G7PUn";
export var modal_register_role__list = "choose_modal-module--modal_register_role__list--XPwS1";
export var register_button = "choose_modal-module--register_button--BDsWy";
export var register_modal_text = "choose_modal-module--register_modal_text--WojWQ";
export var register_text_description = "choose_modal-module--register_text_description--zVArd";
export var register_text_header = "choose_modal-module--register_text_header--Pe6lP";
export var small_modall_header = "choose_modal-module--small_modall_header--QwMby";